import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, isRef as _isRef, mergeProps as _mergeProps, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

import { useField } from "vee-validate";
import { useAttrs } from "vue";
import {QuillEditor} from "@vueup/vue-quill";
import '@vueup/vue-quill/dist/vue-quill.snow.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'AbitEditor',
  props: {
    name: {},
    label: {},
    horizontal: { type: [String, Boolean] },
    required: { type: Boolean },
    wrapperClass: {},
    events: {}
  },
  setup(__props: any) {

const props = __props;

const attrs = useAttrs();

const { value, errorMessage } = useField(props.name);

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            props.wrapperClass || '',
            props.horizontal && 'horizontal-wrapper',
            'abit-editor',
            {'abit-editor--error': _unref(errorMessage)}
        ])
  }, [
    (props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass([
                'form-label',
                props.required && 'required',
                props.horizontal && 'horizontal',
            ])
        }, _toDisplayString(props.label), 3))
      : _createCommentVNode("", true),
    _createVNode(_unref(QuillEditor), _mergeProps({
      name: props.name,
      contentType: "html"
    }, _unref(attrs), _toHandlers(_ctx.events), {
      content: _unref(value),
      "onUpdate:content": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
      theme: "snow"
    }), null, 16, ["name", "content"]),
    _createVNode(_component_el_form_item, {
      error: _unref(errorMessage),
      class: _normalizeClass([{'form-item-horizontal' : props.horizontal}]),
      validateStatus: _unref(errorMessage) ? 'error' : 'success'
    }, null, 8, ["error", "class", "validateStatus"])
  ], 2))
}
}

})